'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _utils = require('../utils');

var _utils2 = _interopRequireDefault(_utils);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var animation = weex.requireModule('animation');
var dom = weex.requireModule('dom');
var modal = weex.requireModule('modal');
exports.default = {
  props: {
    width: {
      type: String,
      default: '750px'
    },
    textWidth: {
      type: String,
      default: '750px'
    },

    height: {
      type: String,
      default: '80px'
    },
    direction: {
      type: String,
      // or column
      default: 'row'
    },
    text: {
      type: [String, Array]
    },
    fontSize: {
      type: String,
      default: '32px'
    },
    textColor: {
      type: String,
      default: '#333'
    },
    bgColor: {
      type: String,
      default: '#fff'
    },
    duration: {
      type: Number,
      // ms
      default: 5000
    },
    delay: {
      type: Number,
      // ms
      default: 0
    }
  },
  data: function data() {
    return {
      base: {
        x: Number(this.textWidth.replace('px', '')),
        t: this.duration,
        h: Number(this.height.replace('px', ''))
      },
      marquee1: {},
      marquee2: {},
      wrapStyle: {},
      baseStyle: {}
      // textStyle: {}
    };
  },
  created: function created() {
    this.wrapStyle = {
      width: this.width,
      height: this.height,
      'background-color': this.bgColor
    };
    var width = this.direction === 'row' ? this.textWidth : this.width;
    this.baseStyle = {
      width: width,
      height: this.height,
      'background-color': this.bgColor
    };

    this.baseStyleWrap = Object.assign({}, this.baseStyle, {
      height: this.base.h * (this.text.length + 1) + 'px'
    });

    // const textStyle = {
    //   height: this.height,
    //   width: width,
    //   'font-size': this.fontSize,
    //   color: this.textColor,
    //   'line-height': this.height
    // }

    // if (Utils.env.isWeb()) textStyle.display = 'block'
    // this.textStyle = textStyle
  },

  computed: {
    textStyle: function textStyle() {
      var width = this.direction === 'row' ? this.textWidth : this.width;
      var tmp = {
        height: this.height,
        width: width,
        'font-size': this.fontSize,
        color: this.textColor,
        'line-height': this.height
      };

      if (_utils2.default.env.isWeb()) tmp.display = 'block';
      return tmp;
    }
  },
  mounted: function mounted() {
    if (this.direction === 'row' && this.base.x > 750) {
      this.initStyle();
      this.startRow();
    } else if (this.direction === 'column') {
      this.startCol();
    }
  },


  methods: {
    initStyle: function initStyle() {
      var base = { height: this.height, width: this.textWidth };
      if (_utils2.default.env.isWeb()) {
        this.marquee1 = Object.assign({
          left: '0px'
        }, base);
        this.marquee2 = Object.assign({
          left: this.base.x + 'px'
        }, base);
      } else {
        this.marquee1 = Object.assign({
          transform: 'translateX(0px)'
        }, base);
        this.marquee2 = Object.assign({
          transform: 'translateX(' + this.base.x + 'px)'
        }, base);
      }
    },
    startRow: function startRow() {
      var _this = this;

      setTimeout(function () {
        _this.animation1('marquee1');
        _this.animation2('marquee2');
      }, this.delay);
    },
    startCol: function startCol() {
      var _this2 = this;

      var index = 0;
      var d = this.duration;
      var next = function next() {
        if (index > _this2.text.length - 1) {
          index = d = 0;
          _this2.animationCol(0, 0);
        } else {
          d = _this2.duration;
          index++;
          var y = -1 * index * 100 / (_this2.text.length + 1) + '%';
          _this2.animationCol(_this2.duration, y);
        }
        // 在动画结束后延迟100ms执行，解决莫名其妙的兼容性bug
        setTimeout(next, d + 100);
      };
      setTimeout(function () {
        next();
      }, this.delay);
    },
    animation1: function animation1(ref) {
      var _this3 = this;

      var el = this.$refs[ref];
      animation.transition(el, {
        styles: this.getStyles(-this.base.x),
        duration: this.base.t,
        timingFunction: 'linear'
      }, function () {
        _this3.end(ref);
      });
    },
    getStyles: function getStyles(x) {
      if (_utils2.default.env.isWeb()) {
        return { left: x + 'px' };
      } else {
        return { transform: 'translateX(' + x + 'px)' };
      }
    },
    animation2: function animation2(ref) {
      var _this4 = this;

      var el = this.$refs[ref];
      var x = this.base.x;
      var d = this.base.t * 2;
      animation.transition(el, {
        styles: this.getStyles(-x),
        duration: d,
        timingFunction: 'linear'
      }, function () {
        _this4.end(ref);
      });
    },
    end: function end(ref) {
      var _this5 = this;

      var el = this.$refs[ref];
      animation.transition(el, {
        styles: this.getStyles(this.base.x),
        duration: 0
      });
      setTimeout(function () {
        _this5.animation2(ref);
      }, 20);
    },
    animationCol: function animationCol(duration, y) {
      var el = this.$refs.wrapColumn;
      if (_utils2.default.env.isWeb()) {
        el.style.transitionDuration = duration + 'ms';
        el.style.transitionTimingFunction = 'ease';
        el.style.transform = 'translate3d(0, ' + y + ', 0)';
        return;
      }
      animation.transition(el, {
        styles: {
          transform: 'translateY(' + y + ')'
        },
        duration: duration,
        timingFunction: 'ease'
      });
    }
  }
};


//////////////////
// WEBPACK FOOTER
// ./~/weex-vue-loader/lib/script-loader.js!./~/babel-loader/lib!./~/weex-vue-loader/lib/selector.js?type=script&index=0!./packages/dof-marquee/index.vue
// module id = 346
// module chunks = 0 1